import {FormControl, Validators} from '@angular/forms';
import {User} from 'cw-backend';

export class Delivery {
    id: number;
    name: string;
    forecastAt: string
    deliveryAt: string;
    readyAt: string;
    orderItem: any;
    readyBy: User;
    deliveryBy: User;
    documentType: string;
    documentNumber: string;
}